import React, {Component} from "react";
import {connect} from "react-redux";

import * as modules from "../../constants/modules";
import * as componentTypes from "../../constants/componentTypes";

import AuthenticationModal from "./modal/AuthenticationModal";
import BarcodeTestModal from "./modal/BarcodeTestModal";
import BeforeDispenseColorantBatchModal from "./modal/BeforeDispenseColorantBatchModal";
import CanisterBarcodeModal from "../../containers/modal/CanisterBarcodeModal";
import CanisterLevelsModal from "../../containers/modal/CanisterLevelsModal";
import CheckBeforeDispensingModal from "./modal/CheckBeforeDispensingModal";
import ConfirmationModal from "./modal/ConfirmationModal";
import DispensingQuickTintModal from "./modal/DispensingQuickTintModal";
import FindPhraseModal from "./modal/FindPhraseModal";
import HelpModal from "../../containers/modal/HelpModal";
import IntergammaMachineModal from "../apps/gamma/machine/Modal";
import IntergammaOrderModal from "../apps/gamma/order/Modal";
import InvalidBatchNumbersModal from "./modal/InvalidBatchNumbersModal";
import LoadingModal from "./modal/LoadingModal";
import ManualAdditionUnitModal from "./modal/ManualAdditionUnitModal";
import PrintTaskPreviewModal from "./modal/PrintTaskPreviewModal";
import PurgeModal from "../../containers/modal/PurgeModal";
import QuickTintModal from "../../containers/modal/QuickTintModal";
import RedlikeLightModal from "../apps/light/Modal";
import RedlikeModal from "../apps/default/Modal";
import RefillConfirmationModal from "./modal/RefillConfirmationModal";
import RestartModal from "./modal/RestartModal";
import SearchingModal from "./modal/SearchingModal";
import ShowBarcodeModal from "./modal/ShowBarcodeModal";
import SmartPurgeModal from "../../containers/modal/SmartPurgeModal";
import SpectroManualInputModal from "./modal/SpectroManualInputModal";
import StirCanistersModal from "../../containers/modal/StirModal";
import WebViewModal from "./modal/WebviewModal";
import BugReportModal from "./modal/BugReportModal";
import SendOrderModal from "../apps/default/modal/SendOrderModal";
import DatabaseFromExcelModal from "../apps/setup/wizard/modal/DatabaseFromExcelModal";

class Modal extends Component {
    componentDidMount = () => {
        window.jQuery("#modal").focus();
    };

    render() {
        switch (this.props.type) {
            case componentTypes.AUTHENTICATION_MODAL:
                return <AuthenticationModal {...this.props} />;
            case componentTypes.BARCODE_TEST_MODAL:
                return <BarcodeTestModal {...this.props} />;
            case componentTypes.BUG_REPORT_MODAL:
                return <BugReportModal {...this.props} />;
            case componentTypes.CANISTER_BARCODE_MODAL:
                return <CanisterBarcodeModal {...this.props} />;
            case componentTypes.CANISTER_LEVELS_MODAL:
                return <CanisterLevelsModal {...this.props} />;
            case componentTypes.CHECK_BEFORE_DISPENSING_MODAL:
                return <CheckBeforeDispensingModal {...this.props} />;
            case componentTypes.CONFIRMATION_MODAL:
                return <ConfirmationModal {...this.props} />;
            case componentTypes.CREATE_ORDER_MODAL:
                return <SendOrderModal {...this.props} />;
            case componentTypes.DATABASE_FROM_EXCEL_MODAL:
                return <DatabaseFromExcelModal {...this.props} />;
            case componentTypes.DISPENSING_QUICK_TINT_MODAL:
                return <DispensingQuickTintModal {...this.props} />;
            case componentTypes.FIND_TEXT_MODAL:
                return <FindPhraseModal {...this.props} />;
            case componentTypes.HELP_MODAL:
                return <HelpModal {...this.props} />;
            case componentTypes.INVALID_BATCH_NUMBERS_MODAL:
                return <InvalidBatchNumbersModal {...this.props} />;
            case componentTypes.LOADING_MODAL:
                return <LoadingModal {...this.props} />;
            case componentTypes.MANUAL_ADDITION_UNIT_MODAL:
                return <ManualAdditionUnitModal {...this.props} />;
            case componentTypes.PRINT_TASK_PREVIEW_MODAL:
                return <PrintTaskPreviewModal {...this.props} />;
            case componentTypes.PURGE_MODAL:
                return <PurgeModal {...this.props} />;
            case componentTypes.QUICK_TINT_MODAL:
                return <QuickTintModal {...this.props} />;
            case componentTypes.REFILL_CONFIRMATION_MODAL:
                return <RefillConfirmationModal {...this.props} />;
            case componentTypes.RESTART_MODAL:
                return <RestartModal {...this.props} />;
            case componentTypes.SEARCHING_MODAL:
                return <SearchingModal {...this.props} />;
            case componentTypes.SHOW_BARCODE_MODAL:
                return <ShowBarcodeModal {...this.props} />;
            case componentTypes.SMART_PURGE_MODAL:
                return <SmartPurgeModal {...this.props} />;
            case componentTypes.SPECTRO_MANUAL_INPUT_MODAL:
                return <SpectroManualInputModal {...this.props} />;
            case componentTypes.STIR_CANISTERS_MODAL:
                return <StirCanistersModal {...this.props} />;
            case componentTypes.WEBVIEW_MODAL:
                return <WebViewModal {...this.props} />;
            case componentTypes.BEFORE_DISPENSE_COLORANT_BATCH_MODAL:
                return <BeforeDispenseColorantBatchModal {...this.props} />;
            default:
                break;
        }

        if (this.props.gammaSoftware) {
            if (this.props.module === modules.MODULE_FRONTDESK || this.props.intergammaOverrideMode) {
                return <IntergammaOrderModal {...this.props} />;
            }

            return (
                <div>
                    <IntergammaMachineModal {...this.props} />
                </div>
            );
        }

        if (this.props.redlikeLightSoftware) {
            return <RedlikeLightModal {...this.props} />;
        }

        return <RedlikeModal {...this.props} />;
    }
}

export default Modal = connect((store) => {
    return {
        module: store.module.name,
        redlikeLightSoftware: store.module.redlikeLightSoftware,
        gammaSoftware: store.module.gammaSoftware,
        intergammaOverrideMode: store.intergammaMachine.overrideMode
    };
})(Modal);
